export function createAccreditationApi(endpoint, fetcher = (...args) => fetch(...args)) {
    const methods = ['requestAccess', 'consumeAccess', 'renewAccess', 'getOrder', 'logout', 'submitTicket', 'updateRegistration', 'cancelRegistration', 'operationStatus', 'inviteTicket', 'resendInvitation', 'revokeInvitation'];
    async function call(action, data = {}) {
        const response = await fetcher(endpoint, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-Accreditation': '1' },
            body: JSON.stringify({ action, data }),
        });
        const payload = await response.json();
        if (!response.ok || payload.error) {
            if (payload.error && payload.error.key) throw payload.error;
            throw new Error('Uncertain accreditation response');
        }
        if (!payload.result) throw new Error('Invalid accreditation response');
        return payload.result;
    }
    return Object.fromEntries(methods.map(action => [action, data => call(action, data)]));
}
